import React, { useContext } from 'react';
import { KioskContext } from '../context/kiosk';

/**
 * Hook custom para usar el contexto de Kiosk
 * Proporciona acceso simplificado a las funciones de inactividad
 */
export const useKioskInactivity = () => {
  const { 
    inactivityWarningActive, 
    setInactivityWarningActive,
    inactivityTimeoutMs,
    setInactivityTimeoutMs,
    setLogoutKiosk,
    setLoginKiosk
  } = useContext(KioskContext);

  return {
    isWarningActive: inactivityWarningActive,
    showWarning: () => setInactivityWarningActive(true),
    hideWarning: () => setInactivityWarningActive(false),
    inactivityTimeoutMs,
    setInactivityTimeoutMs,
    logout: setLogoutKiosk,
    login: setLoginKiosk
  };
};

